import { WEBSITE_ORDER_CHANNEL } from "@/constants/orderChannel"
import { getRestaurantId } from "@/config/restaurant-id"

/**
 * Cache key still includes bootstrap RestaurantId for tenant segmentation.
 * HTTP catalog fetch no longer puts RestaurantId in the URL (public storefront menu).
 */
export function menuCatalogQueryKey(restaurantId: string = getRestaurantId()): string {
  return `menu|catalog|${restaurantId.trim()}|${WEBSITE_ORDER_CHANNEL}`
}
